module.exports = __webpack_public_path__ + "static/media/asta.b4c3ecc3.png";